<template>
  <CustomModal ref="modal" class="edit-business-modal" title="Modifier les informations">
    <div>
      <CustomForm ref="form" :inputs=inputs :submit=buttons.submit>
        <div class="form-container">
          <div class="section">
            <h3 class="section-title">Mon entreprise</h3>
            <CustomTextAreaField :content=inputs.companyInformation :auto-grow="true" :min-height="120" />
            <CustomTextField :content=inputs.tvaNumber />
          </div>
          <div class="section">
            <h3 class="section-title">Conditions</h3>
            <div class="inline-fields">
              <CustomSelectField :content=inputs.quoteValidityPeriod />
              <CustomSelectField :content=inputs.invoicePaiementPeriod />
            </div>
            <CustomTextAreaField :content=inputs.additionalInformation :auto-grow="true" :min-height="120" />
          </div>
        </div>
        <CustomButton class="submit-button" @click="submitForm" :params=buttons.submit style="margin-top: 15px" />
      </CustomForm>
    </div>
  </CustomModal>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faXmark, faPlus, faUpLong, faCheck, faExclamation } from "@fortawesome/free-solid-svg-icons";
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import CustomTextField from "@/components/forms/customs/customTextField/CustomTextField.vue";
import CustomSelectField from "@/components/forms/customs/customSelectField/CustomSelectField.vue";
import {BUSINESS_STATUS_ENUM} from "@/models/businessStatusEnum";
import {NotificationService} from "@vues/v-common";
import {BusinessController} from "@/controllers/business/BusinessController";
import CustomForm from "@/components/forms/CustomForm.vue";
import CustomModal from "@/components/modals/CustomModal.vue";
import {isEditableBusiness} from "@/utils";
import CustomTextAreaField from "@/components/forms/customs/customTextAreaField/CustomTextAreaField.vue";
library.add(faXmark);
library.add(faPlus);
library.add(faCheck);
library.add(faUpLong);
library.add(faExclamation);

export default {
  name: 'EditGeneralInfosBusinessModal',
  computed: {
    BUSINESS_STATUS_ENUM() {
      return BUSINESS_STATUS_ENUM
    }
  },
  props: ['callback'],
  components: {
    CustomTextAreaField, CustomModal, CustomForm, CustomSelectField, CustomTextField, CustomButton},
  data() {
    return {
      business: undefined,
      inputs: {
        companyInformation: {label: 'Information entreprise', value: ''},
        tvaNumber: {label: 'Numéro de TVA', value: '', type: 'text'},
        bank: {label: 'Coordonnées bancaires', value: ''},
        additionalInformation: {label: 'Informations complémentaires', value: ''},
        quoteValidityPeriod: {label: 'Période de validité', value: '', type: 'select', selectValues: [{label:"45", value: 45}, {label:"30", value: 30}, {label:"15", value: 15}]},
        invoicePaiementPeriod: {label: 'Délai de paiement', value: '', type: 'select', selectValues: [{label:"45", value: 45}, {label:"30", value: 30}, {label:"15", value: 15}, {label:"A la réception", value: 0}]},
      },
      buttons:{
        submit: {text: "Valider"}
      },
      isTerminateButtonDisplayed: false
    };
  },
  methods: {
    openModal(business) {
      this.$refs.modal.openModal();
      this.$refs.form?.startLoading();
      this.business = business;
      this.buttons.submit.disabled = false;
      this.inputs.companyInformation.value = business.companyInformation;
      this.inputs.tvaNumber.value = business.tvaNumber;
      this.inputs.bank.value = business.bank;
      this.inputs.additionalInformation.value = business.additionalInformation;
      this.inputs.quoteValidityPeriod.value = business.quoteValidityPeriod;
      this.inputs.invoicePaiementPeriod.value = business.invoicePaiementPeriod;

      this.setReadOnlyIfAmendment(!!business.amendmentOfBusinessId);
      this.setReadOnly(!isEditableBusiness(business));

      this.$refs.form?.stopLoading();
    },
    closeModal() {
      this.$refs.modal?.closeModal();
    },
    terminate() {
      this.closeModal();
      this.callback();
    },
    setReadOnly(readOnly) {
      this.inputs.quoteValidityPeriod.readOnly = readOnly;
      this.inputs.invoicePaiementPeriod.readOnly = readOnly;
      this.inputs.bank.readOnly = readOnly;
      this.inputs.additionalInformation.readOnly = readOnly;
      this.inputs.tvaNumber.readOnly = readOnly;
      this.inputs.companyInformation.readOnly = readOnly;
    },
    setReadOnlyIfAmendment(isAmendment) {
      this.inputs.tvaNumber.readOnly = isAmendment;
      this.inputs.companyInformation.readOnly = isAmendment;
    },
    async submitForm() {
      if (this.business.status === BUSINESS_STATUS_ENUM.DONE.value) {
        this.closeModal();
        return;
      }

      const res = await this.$refs.form.submitForm(() => BusinessController.patch(this.business.id, {
        companyInformation: this.inputs.companyInformation.value,
        tvaNumber: this.inputs.tvaNumber.value,
        quoteValidityPeriod: this.inputs.quoteValidityPeriod.value,
        invoicePaiementPeriod: this.inputs.invoicePaiementPeriod.value,
        bank: this.inputs.bank.value,
        additionalInformation: this.inputs.additionalInformation.value
      }));
      if (!res.errors) {
        (new NotificationService).addNotification("success", "Contrat modifié");
        this.terminate();
      }
    }
  }
}

</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.form-container
  display flex
  flex-direction column
  gap 8px

// Deux blocs : ce qui concerne l'entreprise à gauche, les conditions du document à droite
.section
  display flex
  flex-direction column
  gap 4px
  min-width 0

.section-title
  margin 6px 0 0
  font-size 11.5px
  font-weight 800
  letter-spacing 0.05em
  text-transform uppercase
  color #3a4250

// Période de validité et délai de paiement côte à côte
.inline-fields
  display grid
  grid-template-columns repeat(2, minmax(0, 1fr))
  gap 12px

.submit-button
  margin 20px auto auto

@media only screen and (min-width: DESKTOP_SIZE)
  .form-container
    flex-direction row
    gap 32px

    .section
      flex 1 1 0

  .submit-button
    width 250px
</style>

<style lang="stylus">
.edit-business-modal .modal
  width 720px !important
  max-width 100%
</style>